import ApiService from './ApiService';

class GroupAdminApi extends ApiService {
    constructor() {
        super('group-admin');
    }

    public getUsers = (params?: any) => {
        return this.get('users', params);
    };

    public getPackages = (params?: any) => {
        return this.get('packages', params);
    };

    public getUserDetail = (id: string) => {
        return this.get(`users/${id}`);
    };

    public getUserPublications = (id: string, params?: any) => {
        return this.get(`users/${id}/bookshelf`, params);
    };

    public getUserSubscriptions = (params?: any) => {
        return this.get('subscriptions', params);
    };

    public getPackageItems = (packageId: string, params?: any) => {
        return this.get(`packages/${packageId}/publications`, params);
    };
}

export const groupAdminApi = new GroupAdminApi();
export default GroupAdminApi;
